import { Flows as fishbrainFlows } from '../../companies/Fishbrain/flows/flows';
import { Flows as aspiraFlows } from '../../companies/partners/Aspira/flows/flows';

export const allCompaniesFlows = { ...fishbrainFlows, ...aspiraFlows };
